import { render, staticRenderFns } from "./DialogPrestacion.vue?vue&type=template&id=740cdc69&"
import script from "./DialogPrestacion.vue?vue&type=script&lang=js&"
export * from "./DialogPrestacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports